export const qualities = [
  { value: 'BIO', label: 'BIO' },
  { value: 'Best Beef', label: 'Best Beef' },
  { value: 'GQ', label: 'GQ' },
  { value: 'GVO', label: 'GVO' },
  { value: 'QM', label: 'QM' },
  { value: 'QS', label: 'QS' },
];
